// Packages
import PropTypes from 'prop-types'

// Components
import SupplierForm from 'modules/Suppliers/components/Form';

// Other
import useApi from 'hooks/useApi';

const SupplierCreateScreen = ({ onClose }) => {

    const { post: create, errors } = useApi('/suppliers', false);

    const submit = async (values) => {

        create(values, 'Supplier created!', '/suppliers/');
    }

    return(
        <SupplierForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

SupplierCreateScreen.propTypes = {
	onClose: PropTypes.func,
}

SupplierCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
}

export default SupplierCreateScreen;